import type { RouteLocationRaw } from 'vue-router'
import type { NavigateToOptions } from '#app/composables/router'

export const LANG_PARAM = ':lang([a-z]{2})'

export function joinRoute(...parts: string[]) {
  return '/'.concat(parts.join('/')).replace(/\/+/g, '/')
}

export async function navigate(to: RouteLocationRaw, options: NavigateToOptions = {}) {
  return navigateTo(to, { external: !__IS_MOBILE_APP__, ...options })
}
